import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeWithTimeZoneSelectorComponent } from '../time-with-time-zone-selector/time-with-time-zone-selector.component';
import { MonthlySchedule, ScheduleTime } from '@mode/shared/schedules/contract';
import { DayOfMonthSelectorComponent } from '../day-of-month-selector/day-of-month-selector.component';

@Component({
  standalone: true,
  imports: [CommonModule, DayOfMonthSelectorComponent, TimeWithTimeZoneSelectorComponent],
  selector: 'mode-monthly-schedule-config',
  templateUrl: './monthly-schedule-config.component.html',
  styleUrls: ['./monthly-schedule-config.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonthlyScheduleConfigComponent {
  @Input() schedule: MonthlySchedule = {
    hour: 0,
    minute: 0,
    timeZone: 'UTC',
    frequency: 'monthly',
    dayOfTheWeek: 'Monday',
    dayOfMonth: '1st',
  };
  @Output() dayOfMonthChanged = new EventEmitter<number>();
  @Output() timeChanged = new EventEmitter<ScheduleTime>();
}
